const jq = window.jQuery;

export const scrollToId = (id, offset = 0) => {
  if (!id) {
    return;
  }

  id = id[0] === '#' ? id : `#${id}`;
  let top;
  try {
    top = jq(id).offset().top + offset;
  } catch {}

  if (!isNaN(top)) {
    jq('html, body').animate({ scrollTop: top }, 700);
  }
};

export const scrollToTop = () => setTimeout(() => window.scrollTo(0, 0));

export default {
  scrollToId,
  scrollToTop
};
